import {useEffect, useState} from "react";
import {ApplicationUserApi, ApplicationUserDto, ApplicationUserRegisterDto} from "../../api";
import {useInjection} from "inversify-react";
import ApiService from "../../services/apiService";
import UserList from "./userList";
import {Layout, message} from "antd";
import {Content} from "antd/lib/layout/layout";
import styles from "../beerLower/beerListContainer.module.scss";
import UserModalFormAddContainer from "./userModalFormAddContainer/userModalFormAddContainer";

export default function UserListContainer() {
    const apiService = useInjection(ApiService);

    const [users, setUsers] = useState<ApplicationUserDto[] | null>(null);
    const [addFormVisible, setAddFormVisible] = useState<boolean>(false);
    const [userModalFormContainerTitle, setUserModalFOrmContainerTitle] = useState<string>();
    const [userToEdit, setUserToEdit] = useState<ApplicationUserDto | null>(null);
    const [idUserToEdit, setIdUserToEdit] = useState<number | null>(null)

    const refreshUserList = async () => {
        let u = await apiService.getApi(ApplicationUserApi).apiApplicationUserGet();
        setUsers(u.data);
    }

    useEffect(() => {
        refreshUserList();
    }, [])

    const onAddClicked = () => {
        setUserModalFOrmContainerTitle("Dodaj nowego użytkownika");
        setUserToEdit(null);
        setIdUserToEdit(null);
        setAddFormVisible(true);
    }

    const onSubmit = async (values: ApplicationUserRegisterDto) => {
        try {
            if (userToEdit === null) {
                let newUser = values;
                values.withInvitation = true;
                await apiService.getApi(ApplicationUserApi).apiApplicationUserPost(newUser);
                message.success("Pomyślnie dodano nowego użytkownika");
            } else if (idUserToEdit !== null) {
                values.userName = userToEdit.email;
                await apiService.getApi(ApplicationUserApi).apiApplicationUserIdPut(idUserToEdit, values);
                message.success("Pomyślnie zaktualizowano użytkownika");
            }
        } catch (e: any) {
            return e.response.data;
        }

        setAddFormVisible(false);
        refreshUserList();
    }

    const onEditClicked = async (id: number) => {
        setUserModalFOrmContainerTitle("Edytuj użytkownika");

        const response = await apiService.getApi(ApplicationUserApi).apiApplicationUserIdGet(id);

        setUserToEdit(response.data as ApplicationUserDto);
        setIdUserToEdit(id);
        setAddFormVisible(true);
    }

    const onDeleteClicked = async (id: number) => {
        const response = await apiService.getApi(ApplicationUserApi).apiApplicationUserIdDelete(id);
        if (response.request.status !== 200) {
            console.log("Error occured while deleting data"); //add some warning?
        } else {
            refreshUserList();
        }
    }

    const onResendInvitation = async (email: string) => {
        try {
            await apiService.getApi(ApplicationUserApi).apiApplicationUserResendGet(email)
            message.success("Pomyślnie wysłano wiadomość z zaproszeniem")
        } catch (e: any) {
            return e.response?.data;
        }
    }

    return <Layout style={{backgroundColor: "white"}}>
        <h1>Lista użytkowników</h1>
        <Content className={styles.content}>
            <UserList
                data={users}
                onAddClicked={onAddClicked}
                onEditClicked={onEditClicked}
                onDeleteClicked={onDeleteClicked}
                onResendInvitation={onResendInvitation}
            />
            <UserModalFormAddContainer
                onFinish={() => setAddFormVisible(false)}
                onSubmit={onSubmit}
                title={userModalFormContainerTitle || ""}
                addFormVisibility={addFormVisible}
                userToEdit={userToEdit}
            />
        </Content>
    </Layout>
}
